'use strict';

define(['app', 'elementViewed'], function (app, elementViewed) {

  var buyingRightNow = function buyingRightNow() {

    var component = {};

    var _init = function _init(element) {
      component.element = element;
      component.bind();
      return component;
    };

    var _bind = function _bind() {
      component.elementViewed(component.element, component.buyingRightNowViewed);
    };

    var _buyingRightNowViewed = function _buyingRightNowViewed() {
      app.publish('tracking/record', 'Widget Track', 'Viewed', component.element.getAttribute("data-widget-description"), component.element.getAttribute("data-widget-id"));
    };

    component.elementViewed = elementViewed;
    component.init = _init;
    component.bind = _bind;
    component.buyingRightNowViewed = _buyingRightNowViewed;
    return component;
  };

  return buyingRightNow;
});

// Equivalent class based version
//
// define(['app', 'elementViewed'], function(app, elementViewed) {
//
//   class buyingRightNow {
//     constructor() {
//       this.elementViewed = elementViewed;
//     }
//
//     init(element) {
//       this.element = element;
//       this.bind();
//       this.elementViewed(element, this.buyingRightNowViewed);
//       return this;
//     };
//
//     bind() {
//       this.buyingRightNowViewed = this.buyingRightNowViewed.bind(this);
//     }
//
//     buyingRightNowViewed() {
//       app.publish('tracking/record', 'Widget Track', 'Viewed', this.element.getAttribute("data-widget-description"), this.element.getAttribute("data-widget-id"));
//     };
//
//   }
//
//   return buyingRightNow;
// });
//# sourceMappingURL=responsiveBuyingRightNow.js.map
